import { WorkbookCycleParameterJson, WorkbookCycleParameter } from '@models/workbook-cycle-parameter';

export interface SubPcgEntryJson {
  id: number;
  account_number: string;
  label: string;
  review_cycle?: Partial<WorkbookCycleParameterJson>;
}

export class SubPcgEntry {
  constructor(
    public id?: number,
    public accountNumber?: string,
    public label?: string,
    public reviewCycle?: WorkbookCycleParameter
  ) {}

  static fromJson(json: Partial<SubPcgEntryJson>): SubPcgEntry {
    return new SubPcgEntry(
      json.id,
      json.account_number,
      json.label,
      json.review_cycle ? WorkbookCycleParameter.fromJson(json.review_cycle) : undefined
    );
  }

  static toJson(subPcgEntry: SubPcgEntry): SubPcgEntryJson {
    return {
      id: subPcgEntry.id,
      account_number: subPcgEntry.accountNumber,
      label: subPcgEntry.label
    };
  }
}
